/** Filipino: Workflows P5-5, ang Data connector step. Kapareho ng hugis ng English na teksto; isinasama sa `engage.workflows`. */
export const workflowsConnectorStep = {
  steps: { http_request: "Data connector" },
  summaries: { http_request: "{{method}} {{path}} · {{endpoint}}", http_request_operation: "Tawagan ang {{operation}}" },
  exits: { requestSucceeded: "Nagtagumpay ang request", requestFailed: "Pumalya ang request", requestNotFound: "Walang nahanap", requestRejected: "Tinanggihan ng system", requestUnavailable: "Hindi available ang system" },
  conditionGroups: { variable: "Mga variable", connector: "Konektadong system" },
  incomplete: { endpoint: "Piliin ang endpoint na tatawagan", httpBody: "Ayusin ang body ng request", operation: "Piliin ang connector operation na tatawagan" },
  connector: {
    mode: {
      label: "Paano tatawagan ng step ang system",
      operation: "Connector operation",
      inline: "Inline na request",
      operationHint: "Pumili ng isa sa mga operation na inihanda ninyo sa Settings → Connectors. Alam na nito ang address, sign-in at sagot.",
      inlineHint: "Ang orihinal na data connector: request sa webhook endpoint, kasama ang path, body at sagot na imamapa rito.",
    },
    op: {
      plan: "Kailangan ng plan na {{plan}} o mas mataas para tumawag ng connector operation.",
      runsBehind: "Tumatakbo sa likod ng eksena. Susundin ang sariling timeout at retry ng connector; magpapatuloy ang workflow pagkatapos.",
      runsFacing: "Naghihintay ang bisita habang tumatakbo ito: isang subok, hanggang {{seconds}} segundo. Ituturing na pumalya ang tawag na mas matagal pa rito.",
      connector: "Connector",
      connectorHint: "Ang koneksyon sa system na gusto ninyong tawagan.",
      chooseConnector: "Pumili ng connector",
      connectorGone: "Wala na ang connector na ito. Pumili ng iba.",
      connectorGoneOption: "Hindi magamit na connector",
      connectorInactive: "Hindi aktibo ang connector na ito kaya papalya ang step. I-activate ito sa Settings → Connectors.",
      inactiveOption: "{{name}} ({{status}})",
      sandboxOption: "{{name}} (sandbox)",
      statuses: { draft: "draft", paused: "naka-pause", error: "kailangan ng pansin" },
      operation: "Operation",
      operationHint: "Ang itatanong sa system, gaya ng “Hanapin ang estudyante”.",
      chooseOperation: "Pumili ng operation",
      operationGone: "Wala nang operation na may ganoong key ang connector na ito. Pumili ng iba.",
      operationGoneOption: "Hindi magamit na operation ({{key}})",
      operationUnpublished: "Wala pang na-publish na bersyon ang operation na ito kaya papalya ang step. I-publish ito sa Settings → Connectors.",
      unpublishedOption: "{{name}} (hindi pa na-publish)",
      version: "Bersyon {{version}}",
      kinds: { read: "Nagbabasa", write: "Nagbabago ng data", destructive: "Nagbubura ng data" },
      writeNote: "Binabago ng operation na ito ang data sa kabilang system. Tatakbo ito tuwing aabot ang workflow sa step na ito.",
      loading: "Nilo-load ang mga connector",
      loadingOperations: "Nilo-load ang mga operation",
      loadingSignature: "Nilo-load ang detalye ng operation",
      loadFailedTitle: "Hindi namin ma-load ang mga connector",
      operationsFailedTitle: "Hindi namin ma-load ang mga operation",
      loadFailedBody: "Suriin ang koneksyon at subukan ulit.",
      signatureFailed: "Hindi namin mabasa ang mga parameter at output ng operation na ito. Isara ang step at buksan ulit.",
      retry: "Subukan ulit",
      noAccess: "Kailangan ninyo ng pahintulot na tumingin ng mga connector para pumili. Ipagawa ito sa admin.",
      emptyTitle: "Wala pang connector",
      emptyBody: "Ikonekta ang isang system sa Settings → Connectors, magdagdag ng operation at i-publish ito. Saka na ito matatawag ng workflow.",
      add: "Magdagdag ng connector",
      openConnectors: "Buksan ang Connectors",
      noOperationsTitle: "Walang operation ang connector na ito",
      noOperationsBody: "Magdagdag ng operation dito at i-publish, saka bumalik.",
      facts: "Pagkatapos ng tawag, mababasa ng mga susunod na step ang",
      params: {
        title: "Mga parameter",
        hint: "Punan ang bawat parameter mula sa takbo. Puwedeng gumamit ng variable ang value, gaya ng {{example}}.",
        none: "Walang parameter ang operation na ito.",
        requiredLabel: "{{name}} (kailangan)",
        required: "Kailangan ang parameter na ito.",
        tooLong: "Masyadong mahaba ang value (hanggang {{max}} character).",
        oneOf: "Isa sa: {{values}}.",
        types: { string: "Text", integer: "Buong numero", number: "Numero", boolean: "Oo o hindi (true / false)", array: "Listahan", object: "Object" },
        stale: "Hindi na bahagi ng operation na ito ang parameter na {{name}}.",
        removeStale: "Alisin",
      },
      outputs: {
        title: "Mga output",
        hint: "Mga value na ibinabalik ng operation. Isinasave ang bawat isa sa run variable gaya ng {{example}} para sa mga susunod na step.",
        none: "Walang ibinibigay na output ang operation na ito.",
        into: "I-save sa",
        intoFor: "Run variable para sa {{name}}",
        problems: { variable: "Gamitin ang var. at saka letra, numero o _ (halimbawa var.status).", duplicate: "May ibang output nang pumupuno sa variable na ito." },
      },
      test: {
        title: "Subukan",
        intro: "Tinatawagan nang minsan ang operation sa pamamagitan ng test console ng Connectors, gamit ang sample na value. Wala nang ibang tatakbo sa workflow.",
        sample: "Mga sample na value",
        sampleHint: "Ang mga variable na ginagamit ng mga parameter ninyo. I-type ang magiging laman sa isang takbo.",
        samplePlaceholder: "Isang sample na value",
        run: "Subukan ang tawag",
        running: "Tumatawag…",
        locked: "Kailangan ng plan na {{plan}} o mas mataas para sumubok.",
        needOperation: "Pumili muna ng connector at operation.",
        noAccess: "Kailangan ninyo ng pahintulot sa test console para sumubok.",
        succeeded: "Gumana ang tawag",
        failed: "Hindi gumana ang tawag",
        status: "Status {{status}}",
        noStatus: "Walang sagot",
        duration: "{{ms}} ms",
        environment: "Environment: {{environment}}",
        valuesTitle: "Mga value na isasave",
        valuesNone: "Walang ibinalik ang operation na maisasave.",
        refused: { invalid_params: "May kulang o maling uri ang isang parameter.", connector_inactive: "Hindi aktibo ang connector.", not_published: "Walang na-publish na bersyon ang operation.", unknown: "Tinanggihan ang tawag bago ito umalis." },
        callFailed: {
          rate_limited: "Napakaraming pagsubok. Maghintay ng isang minuto at subukan ulit.",
          not_found: "Hindi nahanap ang connector o operation.",
          forbidden: "Wala kayong pahintulot na sumubok ng mga operation.",
          plan: "Hindi kasama sa plan ninyo ang test console ng Connectors.",
          network: "Hindi namin maabot ang Sagot. Suriin ang koneksyon at subukan ulit.",
          unknown: "Hindi naisagawa ang pagsubok. Subukan ulit.",
        },
      },
    },
    plan: "Kailangan ng plan na {{plan}} o mas mataas para sa data connector.",
    planBadge: "Plan na {{plan}}",
    runsBehind: "Tumatakbo sa likod ng eksena. Hanggang {{seconds}} segundo ang hihintayin sa sagot; magpapatuloy ang workflow pagkatapos.",
    runsFacing: "Naghihintay ang bisita habang tumatakbo ang request na ito: hanggang {{seconds}} segundo. Ituturing na pumalya ang request na mas matagal pa rito.",
    fields: {
      method: "Method",
      path: "Path",
      pathHint: "Idinadagdag sa address ng endpoint, gaya ng {{example}}. Awtomatikong na-eencode ang mga variable.",
      timeout: "Maghintay ng sagot nang hanggang (segundo)",
      timeoutHint: "1 hanggang {{max}} segundo.",
      timeoutHintFacing: "Naghihintay ng sagot ang workflow na nakikita ng bisita, kaya hanggang {{max}} segundo lang ito.",
      body: "Body",
      bodyHint: "Isang JSON object. Ilagay ang bawat variable sa loob ng panipi, gaya ng {{example}}.",
      bodyNone: "Walang body ang GET request.",
      bodyOnGet: "May body pa ang request na ito, at hindi puwedeng magkaroon nito ang GET request. Alisin ito, o piliin ang POST, PUT o PATCH.",
      clearBody: "Alisin ang body",
      variables: "Mga variable na magagamit",
      variablesEarlier: "at ang mga halagang na-save ng naunang hakbang, gaya ng {{example}}",
    },
    problems: {
      path: { long: "Masyadong mahaba ang path (hanggang {{max}} karakter).", slash: "Simulan ang path sa slash, gaya ng /students.", chars: "Hindi puwede ang ?, #, @, backslash o espasyo sa path. Gamitin ang mga parameter sa ibaba para sa query.", dots: "Hindi puwede ang bahaging . o .. sa path." },
      body: { json: "Hindi pa ito wastong JSON. Ilagay ang bawat variable sa loob ng panipi.", object: "Gumamit ng JSON object, gaya ng halimbawa sa kahon." },
      row: { name: "Letra, numero at - lang ang gamitin (puwede rin ang . at _ sa query).", forbidden: "Hindi puwedeng ilagay sa workflow ang mga credential. Itakda ang mga ito sa endpoint sa Settings → Webhooks.", duplicate: "Dalawang beses nagamit ang pangalang ito.", value: "Masyadong mahaba ang halaga." },
      map: { pointer: "Magsulat ng path ng field na nagsisimula sa slash, gaya ng /data/status.", variable: "Letra, numero at _ ang gamitin sa pangalan ng variable.", duplicate: "May ibang row na pumupuno na sa variable na ito." },
    },
    endpoint: {
      label: "Endpoint",
      hint: "Isang webhook endpoint na nakatakda sa “Mula lang sa mga workflow ko” at may format na Sagot. Hawak nito ang address at ang signing secret.",
      choose: "Pumili ng endpoint",
      disabledOption: "{{name}} (naka-disable)",
      unavailableOption: "Hindi magagamit na endpoint",
      unavailable: "Wala na ang endpoint na ito, naka-disable, o hindi na nakatakda sa “Mula lang sa mga workflow ko”. Pumili ng iba o ayusin ito sa Settings → Webhooks.",
      loading: "Nilo-load ang mga endpoint",
      loadFailedTitle: "Hindi namin ma-load ang mga endpoint",
      loadFailedBody: "Tingnan ang inyong koneksyon at subukan ulit.",
      retry: "Subukan ulit",
      noAccess: "Kailangan ng pahintulot na mamahala ng webhook para makita ang mga endpoint. Humingi ng tulong sa admin.",
      emptyTitle: "Wala pang endpoint para sa mga workflow",
      emptyBody: "Magdagdag ng webhook endpoint at itakda ito sa “Mula lang sa mga workflow ko” para matawagan ng connector.",
      add: "Magdagdag ng endpoint",
      openWebhooks: "Buksan ang Webhooks",
      authSet: "Ipinapadala ang header na {{header}} (••••{{last4}}) sa bawat request.",
      authNone: "Walang authentication ang endpoint na ito. Kung kailangan ng API ng key, idagdag ito sa Settings → Webhooks.",
    },
    rows: {
      name: "Pangalan",
      value: "Halaga",
      remove: "Alisin",
      query: { label: "Mga query parameter", add: "Magdagdag ng parameter", empty: "Wala", namePlaceholder: "grade", valuePlaceholder: "11" },
      headers: { label: "Mga header", hint: "Para sa mga label gaya ng X-Branch. Sa endpoint ilagay ang mga password at key, hindi dito.", add: "Magdagdag ng header", empty: "Wala", namePlaceholder: "X-Branch", valuePlaceholder: "Main" },
    },
    map: {
      label: "I-save ang sagot",
      hint: "Pumili ng mga field ng JSON na sagot at bigyan ng variable ang bawat isa. Magagamit ito ng mga susunod na hakbang bilang {{example}}. Puwedeng i-save ang teksto, numero at true/false; hindi ang listahan at object.",
      pointer: "Field sa sagot",
      pointerPlaceholder: "/data/status",
      variable: "Variable",
      variablePlaceholder: "enrol_status",
      add: "Magdagdag ng field",
      remove: "Alisin ang field",
      empty: "Walang sine-save mula sa sagot. Alam pa rin ng mga susunod na hakbang kung gumana ito: {{ok}} at {{status}}.",
      row: "Field {{n}}",
      facts: "Magagamit din pagkatapos",
    },
    exits: {
      label: "Pagkatapos ng request",
      hint: "Ang walang piniling exit ay didiretso sa susunod na hakbang. Isinusulat sa run log ang pumalyang request.",
      success: "Kung nagtagumpay, pumunta sa",
      failure: "Kung pumalya, pumunta sa",
      next: "Ang susunod na hakbang",
    },
    test: {
      title: "Subukan ang request",
      intro: "Isang beses ipapadala ang request gamit ang mga halaga sa ibaba. Makikita ninyo kung ano ang bumalik, hindi ang mismong sagot.",
      needEndpoint: "Pumili ng endpoint na susubukan.",
      needFix: "Ayusin muna ang request.",
      locked: "Kailangan ng plan na {{plan}} para makapagsubok.",
      sample: "Mga halaga para sa pagsubok",
      sampleHint: "Ginagamit kapalit ng mga variable habang sinusubukan.",
      samplePlaceholder: "Isang halimbawang halaga",
      run: "Subukan ang request",
      running: "Sinusubukan…",
      resultTitle: "Resulta",
      status: "Status {{status}}",
      noStatus: "Walang sagot",
      duration: "{{ms}} ms",
      succeeded: "Gumana ang request",
      failed: "Pumalya ang request",
      mappedTitle: "Ang ise-save",
      mappedNone: "Wala pang naka-map. Pumili ng mga field sa ibaba.",
      skippedTitle: "Hindi na-save",
      skipped: { missing: "{{to}}: wala ang field sa sagot", not_scalar: "{{to}}: listahan o object ang field" },
      fieldsTitle: "Mga field sa sagot",
      fieldsNone: "Walang field sa sagot na puwedeng i-save.",
      useField: "Gawing variable",
      useFieldFor: "Gawing variable ang {{pointer}}",
      mapped: "Na-save",
      notMappable: "Hindi puwedeng i-save ang listahan, object at null",
      callFailed: {
        rate_limited: "Marami na kayong sinubukan ngayon lang. Maghintay ng isang minuto at subukan ulit.",
        not_found: "Wala na ang endpoint na iyon. Pumili ng iba.",
        forbidden: "Wala kayong pahintulot na sumubok ng request.",
        plan: "Kailangan ng plan na Pro para makapagsubok.",
        network: "Hindi namin maabot ang server. Tingnan ang inyong koneksyon at subukan ulit.",
        unknown: "Hindi tumakbo ang pagsubok. Subukan ulit.",
      },
    },
    errors: {
      endpoint_unavailable: "Naka-disable, nabura o hindi na nakatakda sa “Mula lang sa mga workflow ko” ang endpoint.",
      blocked_destination: "Hindi pinapayagan ang address. Mga pampublikong https address lang ang matatawagan.",
      bad_request: "Hindi mabuo ang request. Tingnan ang path, mga parameter at body.",
      timeout: "Masyadong natagalan ang sagot ng kabilang system.",
      transport: "Hindi kami nakakonekta sa kabilang system.",
      http_status: "Error na status ang isinagot ng kabilang system.",
      too_large: "Masyadong malaki ang sagot.",
      invalid_json: "Hindi JSON ang sagot.",
      rate_limited: "Masyadong maraming request ang naipadala ngayon lang. Subukan ulit sa ilang sandali.",
      run_cap: "Naipadala na ng run na ito ang pinakamaraming request na pinapayagan.",
      time_budget: "Naghintay na ang bisita nang pinakamatagal na pinapayagan sa turn na ito ng usapan.",
      plan: "Hindi kasama sa inyong plan ang data connector.",
      unknown: "Pumalya ang request.",
    },
  },
};
